
import { Translations } from '../types';
import { enTranslations } from './en/index';
import { elTranslations } from './el/index';

// Create and export the translations object
export const translations: Translations = {
  en: enTranslations,
  el: elTranslations
};

// Don't re-export individual modules to avoid naming conflicts
// We will access translations through the translations object instead
